/**
 *
 * Styled icon button
 *
 */
import { ButtonProps as MuiButtonProps } from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import classNames from 'classnames';
import React, { FC } from 'react';

import useStyles from './styles';

export interface StyledIconButtonBaseProps {
  defaultIconColor: boolean;
  isExternalLink: boolean;
  isSelected: boolean;
  primary: boolean;
  isDisabled: boolean;
  // Why this is needed: https://v4.mui.com/guides/typescript/#usage-of-component-prop
  component: React.ElementType;
}

export type StyledIconButtonProps = Partial<StyledIconButtonBaseProps> & MuiButtonProps;

const StyledIconButton: FC<StyledIconButtonProps> = ({
  children,
  className,
  href,
  isDisabled = false,
  isExternalLink = false,
  isSelected = false,
  onClick,
  primary = false,
  size = 'medium',
  defaultIconColor = false,
  ...otherProps
}) => {
  const classes = useStyles({
    defaultIconColor,
    isSelected,
    primary,
    size,
  });

  // An icon carries no text, so the link's name comes from aria-label alone.
  if (isExternalLink) {
    return (
      <a aria-label={otherProps['aria-label']} className={classNames(classes.container, className)} href={href}>
        {children}
      </a>
    );
  }
  return (
    <IconButton
      classes={{ root: classes.container }}
      className={className}
      disabled={isDisabled}
      disableRipple
      onClick={onClick}
      {...otherProps}
    >
      {children}
    </IconButton>
  );
};

export default StyledIconButton;
